import {
  ApiBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

import { rootRouteRef } from './routes';
import { soc2ReportApiRef } from './api/types';
import { Soc2ReportClient } from './api/Soc2ReportClient';
import { SOC2_REPORT_ROUTES } from './navigation';

const soc2ReportApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: soc2ReportApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new Soc2ReportClient({ discoveryApi, fetchApi }),
    }),
});

const soc2ReportPage = PageBlueprint.make({
  params: {
    path: SOC2_REPORT_ROUTES.root.path,
    title: 'SOC2 Report',
    routeRef: rootRouteRef,
    // The page renders its own BUI <FullPage>/<Header> with tabs.
    noHeader: true,
    loader: () =>
      import('./components/Soc2ReportPage').then(m => <m.Soc2ReportPage />),
  },
});

export const soc2ReportPlugin = createFrontendPlugin({
  pluginId: 'soc2-report',
  title: 'SOC2 Report',
  routes: {
    root: rootRouteRef,
  },
  extensions: [soc2ReportApi, soc2ReportPage],
});

export default soc2ReportPlugin;
